
export default {
    methods: {
        $closeDetailBox() {
            this.showDetail = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/ui.js